(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/limit-coverage-info.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/limit-coverage-info.js');

'use strict';

const Paper = svs.ui.ReactPaper;
const capitalizeString = svs.utils.format.capitalize;
const LimitCoverageInfo = _ref => {
  let product = _ref.product,
    amount = _ref.amount,
    period = _ref.period;
  return React.createElement("div", {
    className: "u-flex"
  }, React.createElement(Paper, {
    branding: "tur",
    className: "padding-v-1 padding-h-2 set-limits-paper"
  }, React.createElement("div", null, "Ditt spel p\xE5", ' ', capitalizeString(product, true), ' ', "kostar", ' ', amount, ' ', "kr! Med dina valda gr\xE4nser kommer du inte ha r\xE5d att l\xE4gga n\xE5gra fler spel", ' ', period, ".")));
};
svs.accountservicesReact.gameLimitDepositsForm.LimitCoverageInfo = LimitCoverageInfo;

 })(window);